import { Component, inject } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';

import { SafeUrlPipe } from '../../pipes/safe-url.pipe';
import { CloudinaryService } from '../../../core/services/cloudinary.service';

import { PlanningFormSheetComponent } from '../../sheets/planning-form-sheet/planning-form-sheet.component';

import { Config } from '../../../core/configs/config';

@Component({
    selector: 'app-start-planing-mobile',
    templateUrl: './start-planing-mobile.component.html',
    styleUrls: ['./start-planing-mobile.component.scss'],
    imports: [SafeUrlPipe]
})
export class StartPlaningMobileComponent {
  public startPlanImgF: string = `${Config.imgCdnUrl}images/start-plan-1.png`;
  public startPlanImgS: string = `${Config.imgCdnUrl}images/start-plan-2.png`;

  readonly #matBottomSheet = inject(MatBottomSheet);
  readonly #cloudinaryService = inject(CloudinaryService);

  constructor() {
    this.startPlanImgF = this.#cloudinaryService.getCloudImage(
      this.startPlanImgF,
    );
    this.startPlanImgS = this.#cloudinaryService.getCloudImage(
      this.startPlanImgS,
    );
  }

  openPlanningForm(): void {
    this.#matBottomSheet.open(PlanningFormSheetComponent, {
      hasBackdrop: false,
      closeOnNavigation: true,
      panelClass: 'custom-bottom-sheet',
    });
  }
}
